import { CustomEventCommand, CustomPlaceCommand } from '../../commands/hub/custom.event.command';

export class HubCustomBtn {
    public events: CustomEventCommand[];
    public places: CustomPlaceCommand[];
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.custom.btn.ts